import { apiAuth, apiResponseType } from ".";

export const getClientOriginsData = (page: number = 1): apiResponseType =>
  apiAuth.get(`client-origins?page=${page}`);

export const registerClientOriginsData = (data) =>
  apiAuth.postForm("/client-origins/store", data) as apiResponseType;
export const deleteClientOriginsData = (tenid: string) =>
  apiAuth.delete(`client-origins/${tenid}/destroy`) as apiResponseType;
export const updateClientOriginsData = (tenid: string, data) =>
  apiAuth.postForm(`client-origins/${tenid}/update`, data) as apiResponseType;

export const getShowClientOrigins = (tenid: string) =>
  apiAuth.get(`client-origins/${tenid}/show`) as apiResponseType;

export const searchClientOriginsData = (params: {
  name: string;
}): apiResponseType => apiAuth.get(`client-origins?name=${params.name}`);

export const setStatusClientOrigins = (tenid: string) =>
  apiAuth.put(`client-origins/${tenid}/toggle-status`) as apiResponseType;

export const getSelectClientOrigins = () =>
  apiAuth.get(`client-origins/select`) as apiResponseType;
